/* AJAX add-to-cart for the product form, quick-add buttons and cart cross-sells.
   States: adding (aria-busy), success (2 s, then the cart drawer opens), error. */
(() => {
  const ik = (window.ikTheme = window.ikTheme || {});
  const strings = () => ik.strings || {};

  class IkProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.section = this.closest('.shopify-section') || document;
      this.busy = false;
      this.form.addEventListener('submit', (event) => this.onSubmit(event));

      this.addon = this.form.querySelector('[data-addon]') || (this.form.id ? document.querySelector(`[data-addon][form="${this.form.id}"]`) : null);
      if (this.addon) this.addon.addEventListener('change', () => this.updateTotal());
      document.addEventListener('ik:variant:change', (event) => {
        if (!this.form.id || !event.target.closest || event.target.dataset.form !== this.form.id) return;
        if (event.detail && event.detail.variant) {
          this.form.dataset.currentPrice = event.detail.variant.price;
          this.updateTotal();
        }
      });
      if (this.form.dataset.currentPrice === undefined) {
        const price = this.section.querySelector('[data-price]');
        if (price && price.dataset.cents) this.form.dataset.currentPrice = price.dataset.cents;
      }
      this.updateTotal();
    }

    get buttons() {
      const own = Array.from(this.form.querySelectorAll('[data-add-to-cart]'));
      const external = this.form.id ? Array.from(document.querySelectorAll(`[form="${this.form.id}"][data-add-to-cart-sticky]`)) : [];
      return own.concat(external);
    }

    updateTotal() {
      if (this.form.dataset.currentPrice === undefined) return;
      const base = Number(this.form.dataset.currentPrice) || 0;
      const addon = this.addon && this.addon.checked ? Number(this.addon.dataset.addonPrice || 0) : 0;
      const total = ik.formatMoney(base + addon);
      this.section.querySelectorAll('[data-atc-price]').forEach((el) => {
        el.textContent = total;
      });
    }

    async onSubmit(event) {
      event.preventDefault();
      if (this.busy) return;
      const idInput = this.form.querySelector('[name="id"]');
      if (!idInput || idInput.disabled) return;
      const quantityInput = this.form.querySelector('[name="quantity"]');
      const quantity = Math.max(1, Number(quantityInput ? quantityInput.value : 1) || 1);
      const items = [{ id: Number(idInput.value), quantity }];
      if (this.addon && this.addon.checked) items.push({ id: Number(this.addon.value), quantity: 1 });

      this.setBusy(true);
      this.showError(null);
      try {
        const response = await fetch(ik.routes.cartAdd, {
          ...ik.fetchConfig(),
          body: JSON.stringify({ items, sections: 'cart-drawer', sections_url: window.location.pathname })
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || strings().cartError);
        this.onSuccess(data);
      } catch (error) {
        this.showError(error.message || strings().cartError);
      } finally {
        this.setBusy(false);
      }
    }

    setBusy(on) {
      this.busy = on;
      this.buttons.forEach((button) => {
        if (on) {
          button.setAttribute('aria-busy', 'true');
          button.dataset.originalLabel = button.querySelector('[data-atc-label]')?.textContent || button.textContent;
          const label = button.querySelector('[data-atc-label]');
          if (label) label.innerHTML = `<span class="btn__spinner" aria-hidden="true"></span>${strings().adding || '…'}`;
        } else {
          button.removeAttribute('aria-busy');
        }
      });
    }

    onSuccess(data) {
      const added = Array.isArray(data.items) ? data.items : [data];
      const title = added.length ? added[0].product_title || added[0].title || '' : '';

      if (data.sections && data.sections['cart-drawer']) {
        ik.replaceSection('cart-drawer', data.sections['cart-drawer'], '[data-cart-inner]');
        const marker = document.querySelector('[data-cart-inner] [data-cart-item-count]');
        if (marker) ik.cart.setCount(Number(marker.dataset.cartItemCount));
      }
      document.dispatchEvent(new CustomEvent('ik:cart:updated', { detail: { source: 'add', items: added } }));

      this.buttons.forEach((button) => {
        button.classList.add('btn--success');
        const label = button.querySelector('[data-atc-label]');
        if (label) label.innerHTML = `<svg class="icon" width="20" height="20" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12l5 5 9-10"></path></svg>${strings().added || ''}`;
      });
      const status = this.form.querySelector('[data-form-status]');
      if (status) {
        const notice = (strings().addedNotice || '[title]').replace('{{ title }}', title).replace('[title]', title);
        status.innerHTML = `<span>${notice}</span><a href="${ik.routes.cart}" class="link link--s" data-drawer-open="CartDrawer">${strings().viewCart || ''}</a>`;
        status.hidden = false;
      }
      ik.announce(`${title} – ${strings().added || ''}`);

      window.setTimeout(() => {
        this.buttons.forEach((button) => {
          button.classList.remove('btn--success');
          const label = button.querySelector('[data-atc-label]');
          if (label) label.textContent = strings().addToCart || button.dataset.originalLabel || '';
        });
        const drawer = document.getElementById('CartDrawer');
        if (ik.cartType === 'drawer' && drawer && typeof drawer.open === 'function') {
          drawer.open(this.buttons[0]);
        } else if (ik.cartType !== 'drawer') {
          window.location.href = ik.routes.cart;
        }
      }, 1600);
    }

    showError(message) {
      const error = this.form.querySelector('[data-form-error]');
      if (!error) {
        if (message) ik.announce(message);
        return;
      }
      error.textContent = message || '';
      error.hidden = !message;
      if (message) ik.announce(message);
    }
  }

  if (!customElements.get('ik-product-form')) customElements.define('ik-product-form', IkProductForm);
  if (!customElements.get('ik-quick-add')) customElements.define('ik-quick-add', class extends IkProductForm {});
})();
